import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import { BuilderContainer, BuilderFormValues } from '../containers';
import { BuilderForm } from '../components';

const BuildersCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();
  const { formLoading, createBuilder, setFormLoading } =
    BuilderContainer.useContainer();

  const handleSubmit = useCallback(
    async (values: BuilderFormValues) => {
      setFormLoading(true);
      try {
        await createBuilder(values);
        notify('Element created');
        history.push('/builder');
      } catch (error: unknown) {
        console.error('Builder create failed:', error);
        notify(
          extractErrorMessage(error, 'Failed to create builder'),
          'error',
        );
      } finally {
        setFormLoading(false);
      }
    },
    [createBuilder, history, notify, setFormLoading],
  );

  const handleGoBack = useCallback(() => {
    history.push('/builder');
  }, [history]);

  return (
    <Box className={classes.formContainer}>
      <BuilderForm
        mode="create"
        onSubmit={handleSubmit}
        loading={formLoading}
        onGoBack={handleGoBack}
      />
    </Box>
  );
};

export const BuildersCreate = () => (
  <BuilderContainer.Provider>
    <BuildersCreateInner />
  </BuilderContainer.Provider>
);

const useStyles = makeStyles(theme => ({
  formContainer: {
    position: 'relative',
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
  },
}));

export default BuildersCreate;
